import React, { Component } from 'react';
import { withApollo } from 'react-apollo';
import '../styles/pages/end.scss';
import { QUERY_VOX_URL } from '../utils/graph-api';
import { tspan } from '../utils/i18n';
import {TitleText} from './start';
import styled from 'styled-components';
import { faExternalLink } from '@fortawesome/pro-regular-svg-icons';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import EndButton from "../components/buttons/end";
import { ColoredFooter } from './mic-check';
import { closePluginButton } from '../utils/alt-tags';


const CheckMark = styled(FontAwesomeIcon)`
  width: 30px;
  font-style: normal;
  font-weight: 900;
  font-size: 48px;
  line-height: 48px;
  text-transform: capitalize;
  color: ${(props) => props.common ? props.common.buttonColor : 'linear-gradient(180deg, #FFD815 8.89%, #FF9D05 93.33%)' };
`;
const ExternalLink = styled.div`
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 1.2rem;
  line-height: 16px;
  color: #FF9603;
  margin: auto;
  a { 
   text-decoration: none;
   color: ${(props) => props.common ? props.common.buttonColor : '#FF9603' };

  }
`;
const ExternalIcon = styled(FontAwesomeIcon)`
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  color: ${(props) => props.common ? props.common.buttonColor : '#FF9603' };
`;

class End extends Component {
    state = {
        voxURL: ''
    };

    async componentDidMount() {
        const { id, client, isPublicHosted } = this.props;
        // Get the last uploaded vox
        const { data } = await client.query({
            query: QUERY_VOX_URL,
            variables: { id }
        });
        const { recordingUrl } = data.getVox;

        this.setState({ voxURL: recordingUrl });
        if (isPublicHosted) {
          window.__sharethis__.initialize();
        }
    }
    proceed = ()=> {
        this.props.togglePlugin();
    };


    render() {
      const { voxURL } = this.state;
      const { isPublicHosted, tagThankYouText, token, pluginMode, isFrame } = this.props;
      const { common } = this.props.settings;
      return (
        <>
          <div className="content">
              <div className="plugin-header">
            {/* Title for final page */}
            <div
              className="title"
              style={{
                  wordBreak:'break-word',
                  whiteSpace: 'pre-wrap',
                  // fontFamily: common.fontFamily,
                // color: common.fontColor,
              }}
            >
                <TitleText> {tspan('thankyouTitle')}</TitleText>
            </div>
              </div>
              <div className={`row ${pluginMode ? "mt-3" : "m-0"}`}>
                  <CheckMark icon={faCheck} className="complete-tick" alt="upload-complete" common={common}/>
            {/*<img src={`${process.env.PUBLIC_URL}/img/tick-anim.svg`} className="complete-tick" alt="upload-complete" />*/}
              </div>
            <p
              className="thanks-sub"
              style={{
                  fontStyle: 'normal',
                  fontFamily: 'Titillium Web',
                  fontWeight: 'normal',
                  fontSize: '14px',
                  lineHeight: '20px',
                  color:'#27364E',
                  marginTop: '1rem',
                  wordBreak:'break-word',
                  whiteSpace: 'pre-wrap',
              }}
            >
              {tspan('thankyouSubTitle', { break: <br /> })}
            </p>
            {isPublicHosted && (
              <div
                className="sharethis-inline-share-buttons"
                data-url={`https://www.blessourheroes.org/blessing?${token}`}
                data-title="Listen to this blessing on #BlessOurHeroes and record your own!"
                data-image="https://uploads-ssl.webflow.com/5e7b91255835f10e6c938069/5e98469c234469f40fe36d1a_Pinterest2.png"
              />
            )}
              {tagThankYouText && (tagThankYouText[0] || tagThankYouText[1]) && <p
              className="thanks-sub"
              style={{
                  fontStyle: 'normal',
                  fontFamily: 'Titillium Web',
                  fontWeight: 'normal',
                  fontSize: '14px',
                  lineHeight: '20px',
                  color:'#27364E',
                  marginTop: '1rem',
              }}
            >
                  {tagThankYouText[0] ? tagThankYouText[0] : tagThankYouText[1]}
            </p>}
             {/*{!!voxURL ? (*/}
             {/*<div className={`final-playback ${process.env.REACT_APP_BUILD_MODE}-mode`}>*/}
             {/*/!* {!isMobile.iOS() ? ( *!/*/}
             {/*<audio preload="metadata" controls controlsList="nodownload" src={voxURL}></audio>*/}
             {/*/!* ) : null} *!/*/}
             {/*</div>*/}
             {/*) : null}*/}
              {(!isPublicHosted && common.desiredWebLink)&&
              <ExternalLink
               common={common}
              >
                  <a href={common.desiredWebLink ? common.desiredWebLink.includes('http' || 'https') ?
                      common.desiredWebLink : `https://${common.desiredWebLink}` :
                      ''}
                     rel="noopener noreferrer" target="_parent">
                      {common.anchorText ? common.anchorText : "Visit our website"}   &nbsp;
                      <ExternalIcon
                          common={common}
                          icon={faExternalLink}/>
                  </a>
              </ExternalLink>
              }

          </div>
            <ColoredFooter className="buttons" requiredShadow={common.requiredShadow} hideGreyBar={common.hideGreyBar}>
                {(pluginMode && !isFrame) &&
                <EndButton size="2x" common={common}
                           onClick={this.proceed}
                           micPermission={true}
                           title={closePluginButton}
                />}
            </ColoredFooter>
        </>
      );
    }
}

export default withApollo(End);
